import React from 'react';
import { Bot, Play, Square } from 'lucide-react';
import { Button, BrandName } from '../ui';
import { useTheme } from '../../theme';

interface AvatarCardProps {
  isSpeaking: boolean;
  onSpeak: () => void;
  onStop: () => void;
}

export const AvatarCard: React.FC<AvatarCardProps> = ({
  isSpeaking,
  onSpeak,
  onStop,
}) => {
  const { branding } = useTheme();

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="relative h-14 w-14 flex-shrink-0">
          {isSpeaking && (
            <div className="absolute inset-0 rounded-full bg-blue-500 opacity-25 animate-ping" />
          )}
          <div
            className={`relative h-14 w-14 rounded-full flex items-center justify-center text-white shadow-lg bg-gradient-to-br from-blue-500 to-blue-600 ${
              isSpeaking ? 'ring-4 ring-blue-100' : ''
            }`}
          >
            <Bot className={`h-8 w-8 text-white ${isSpeaking ? 'animate-bounce' : ''}`} />
          </div>
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-gray-900">
            <BrandName text={branding.appTitle || 'mAIthZen'} />
          </div>
          <div className="text-xs font-medium text-blue-600">
            {isSpeaking ? 'Let me explain this...' : 'Ready to help'}
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-100">
        <Button
          variant="primary"
          size="sm"
          className="flex-1"
          icon={<Play className="w-4 h-4" />}
          onClick={onSpeak}
          disabled={isSpeaking}
        >
          Explain
        </Button>
        <Button
          variant="danger"
          size="sm"
          className="flex-1"
          icon={<Square className="w-4 h-4" />}
          onClick={onStop}
          disabled={!isSpeaking}
        >
          Stop
        </Button>
      </div>
    </div>
  );
};

export default AvatarCard;
